export default "__VITE_ASSET__pXetoZ2T__"